import { ObjectConfig, required } from "@homebound/form-state";
import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import { reviewImpactStep, reviewStep } from "src/routes/projects/change-events/guided/workflows/sharedSteps";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";
import { SelectProductToReplaceStep } from "../2.SelectProductToReplaceStep";

export type SwapProductNotInCatalogFormInput = {
  swaps: {
    originalProjectItemId?: string | null;
    // TODO: define replacement variant shape (probably a form object)
    replacementMaterialVariantId?: string | null;
  }[];
};

export const swapProductNotInCatalogFormConfig: ObjectConfig<SwapProductNotInCatalogFormInput> = {
  swaps: {
    type: "list",
    rules: [
      // At least one swap is needed to create the change event
      required,
      // Every swap must have an original and replacement product
      ({ value }) =>
        !value.every((swap) => !!swap.originalProjectItemId.value && !!swap.replacementMaterialVariantId.value)
          ? "Every swap must have an original and replacement product"
          : undefined,
    ],
    config: {
      originalProjectItemId: { type: "value", rules: [required] },
      replacementMaterialVariantId: { type: "value", rules: [required] },
    },
  },
};

export const swapProductNotInCatalogWorkflow = defineWorkflow<SwapProductNotInCatalogFormInput>({
  workflow: ChangeEventWorkflow.SwapProductNotInCatalog,
  formConfig: swapProductNotInCatalogFormConfig,
  steps: [
    {
      value: GuidedChangeEventStep.SelectProductToReplace,
      label: "Select Product to Replace",
      isComplete: (form) => form.valid,
      render: (form) => <SelectProductToReplaceStep formState={form} />,
    },
    reviewImpactStep(),
    reviewStep(),
  ],
  useActions: () => {
    return {
      // TODO: submit the change event for the swap-product-not-in-catalog flow.
      onSubmit: async () => {},
    };
  },
});
